export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputIPAddress",
            data: {
                gate: false,
                onChange,
                attrs: {
                    value: settings[name],
                }
            }
        }
    ]
}